export const DEFAULT_ANIMATION_DURATION = 0.75;
export const CRAFT_CARD_PROPS = [
  {
    card_number: 1,
    main_video_url:
      '//s3.ap-northeast-2.amazonaws.com/s3.marpple.co/files/u_4648126/2024/10/original/knitting_neddles.mp4',
    center_image_url:
      '//s3.marpple.co/files/u_4648126/2024/10/original/08217680b05e2bf8a00102145dfd56701534f62a1.png',
    content_video_url:
      'https://s3.ap-northeast-2.amazonaws.com/s3.marpple.co/files/u_4648126/2024/10/original/glass_heat.mp4',
  },
  {
    card_number: 2,
    main_video_url:
      'https://s3.ap-northeast-2.amazonaws.com/s3.marpple.co/files/u_4648126/2024/10/original/glass_heat.mp4',
    center_image_url:
      '//s3.marpple.co/files/u_4648126/2024/10/original/3f0d3116e7118b5acc260a8fc57e6fa3f1d2c08f1.png',
    content_video_url:
      'https://s3.ap-northeast-2.amazonaws.com/s3.marpple.co/files/u_4648126/2024/10/original/tufting_textile.mp4',
  },
  {
    card_number: 3,
    main_video_url:
      'https://s3.ap-northeast-2.amazonaws.com/s3.marpple.co/files/u_4648126/2024/10/original/tufting_textile.mp4',
    center_image_url:
      '//s3.marpple.co/files/u_4648126/2024/10/original/1cce7c62f6036aadd01c53bd02b6aecfe40bb41b1.png',
    content_image_url:
      '//s3.marpple.co/files/u_4648126/2024/10/original/e95739f963cbaffcf025cee217addc31905531db1.png',
  },
];

export const ONE_SCROLL_INDEX_MAP_PC = {
  initial_index: 0,
  last_index: 10,
  scale_index: 1,
  craft_index: 3,
  video_index: 6,
};

export const ONE_SCROLL_INDEX_MAP_MO = {
  initial_index: 0,
  last_index: 14,
  scale_index: 1,
  video_index: 9,
};
